import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IProduct } from "../../models/catalogue";
import { money } from "../../utils/format";
import { useShouldShowPricing } from "../../utils/settings";

import styles from "./index.module.scss";

type IProps = Immutable<{
    productPrice: IProduct["price"];
    preCopy?: string;
}>;

export const DynamicPrice = (props: IProps): React.JSX.Element => {
    const shouldShowPricing = useShouldShowPricing();
    const { productPrice } = props;

    if (!shouldShowPricing) {
        return <></>;
    }
    if (productPrice.cosmetic_incl_tax !== productPrice.incl_tax) {
        return (
            <div className={styles.priceWrapper}>
                <span className="ada-screenreader-only">{t`Original price:`}</span>
                <span className={styles.strikeThruPrice}>
                    {props.preCopy}{" "}
                    <s key="strikeThruPrice">{money(productPrice.incl_tax)}</s>
                </span>
                <span className="ada-screenreader-only">{t`Current price:`}</span>
                <span className={styles.price}>
                    {money(productPrice.cosmetic_incl_tax)}
                </span>
            </div>
        );
    }
    return <div className={styles.price}>{money(productPrice.incl_tax)}</div>;
};
